import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Garage = createSvgIcon(
  <path d="M24 3.263 12 .035 0 3.263V6.75h2.25V4.987L12 2.365l9.75 2.622V6.75H24V3.263ZM6.125 7.5c-.426 0-.816.24-1.006.622l-1.135 2.27-2.82-.94-.712 2.134 2.135.712L0 14.023V24h7.5v-3h9v3H24v-9.977l-2.587-1.725 2.135-.712-.711-2.134-2.82.94-1.136-2.27a1.125 1.125 0 0 0-1.006-.622H6.125Zm-1.127 5.895L6.82 9.75h10.36l1.822 3.645.774.516-2.743.61.488 2.196 4.229-.94v5.973h-3v-3H5.25v3h-3v-5.973l4.23.94.487-2.196-2.743-.61.774-.516Z" />,
  'Garage'
);

export { Garage };